<template>
  <div id="mai-profile">
    <div class="caseinfo"  v-if="caseInfo.id">
      <div class="header">
        Case Info
      </div>
      <el-card class="box-card body">
        <div><i class="fa fa-folder"></i>{{ caseInfo.id }}</div>
        <div><i class="fa fa-user"></i>{{ caseInfo.name }}</div>
        <div><i class="fa fa-briefcase"></i>{{ caseInfo.type }}</div>
        <div><i class="fa fa-list-alt"></i>{{ caseInfo.assignment }}</div>
        <div><i class="fa fa-compass"></i>{{ caseInfo.location }}</div>
      </el-card>
    </div>
    <div class="participants">
      <div class="header">
        Contacts
      </div>
      <el-card class="box-card body">
        <div v-for="p in filteredParticipants" :key="p.id">
          <div>
            <i class="fa fa-circle" :class="{ 'status-online': p.online, 'status-offline': !p.online }"></i>
            {{ p.name }}
          </div>
        </div>
      </el-card>
    </div>
    <div class="profile">
      <div class="body">
        <div>
          <i class="fa fa-user-circle avatar"></i>
          <span style="vertical-align:middle;position:relative;top:-.7em;">{{userInfo.fullname}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Contacts from './ChatContacts'
import Conversation from './ChatConversation'
export default {
  name: 'MaiChat',
  props: {
    participants: {
      type: Array,
      required: true
    },
    caseInfo: {
      type: Object,
      required: true
    },
    userInfo: {
      type: Object,
      required: true
    }
  },
  components: {
    Contacts,
    Conversation
  },
  data () {
    return {
      fullname: ''
    }
  },
  computed: {
    bottom () {
      return `${this.dimensions.bottom}px`
    },
    right () {
      return `${this.dimensions.right}px`
    },
    filteredParticipants () {
      if (this.participants) {
        return this.participants.filter(({name}) => name !== (this.userInfo && this.userInfo.fullname))
      }
      return []
    }
  },
  methods: {
    drag ({ screenX, screenY }) {
      this.initial.x = screenX
      this.initial.y = screenY
    },
    drop ({ screenX, screenY }) {
      this.end.x = screenX
      this.end.y = screenY
      this.updatePosition()
    },
    updatePosition () {
      this.dimensions.right += this.initial.x - this.end.x
      this.dimensions.bottom += this.initial.y - this.end.y
    },
    onSelection (selection) {
      this.viewing = 'conversation'
    },
    send (msg) {
      this.conversation.push(
        { id: this.id++, from: 1, to: 2, content: msg, time: new Date().getTime() }
      )
      this.message = ''
      setTimeout(this.reply, 1500)
    },
    reply () {
      this.conversation.push(
        { id: this.id++, from: 2, to: 1, content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales.', time: new Date().getTime() }
      )
    }
  },
  watch: {
    viewing (newVal, oldVal) {
      this.conversation = [ ...this.demo ]
      this.message = ''
    }
  },
  mounted () {
    this.username = this.$route.query.userId
    this.topic = this.$route.query.topic
  }
}
</script>
<style lang="scss">
#mai-profile {
  width: 350px;
  padding: 40px 25px 25px 25px;
  .caseinfo {
    background: #fff;
    .header {
      font-size: 20px;
    }
    .body {
      font-size: 16px;
      width: 350px;
    }
  }
  .participants {
    .header {
      padding-top: 30px;
      font-size: 20px;
    }
    .body {
      font-size: 16px;
      width: 350px;
    }
  }
  .profile {
    font-size: 16px;
    .body {
      padding-top: 30px;
    }
  }
  .fa {
    padding-right: 5px;
  }
  .avatar {
    font-size: 40px;
  }
  .status-online {
    color: #67C23A;
  }
  .status-offline {
    color: #949494;
  }
}
</style>



// WEBPACK FOOTER //
// src/sections/chat/MaiProfile.vue